<script>
import iconMixin from "@/mixins/iconMixin";

export default {
  mixins: [iconMixin],
  props: {
    title: {
      type: String
    },
    subtitle: {
      type: [String, Boolean],
      required: false,
      default: false
    }
  }
};
</script>

<template>
  <section>
    <img :src="iconSrc" :height="iconSize" :alt="iconAlt" />
    <h3>{{title}}</h3>
    <div class="subtitle" v-if="subtitle">{{subtitle}}</div>
    <slot></slot>
  </section>
</template>

<style scoped>
section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 14px;
  color: #fff;
  background-color: var(--pink);
  padding: 20px;
  border-radius: 4px;
}

h3 {
  margin: 10px 0 0;
  font-size: 22px;
  font-weight: 300;
}

.subtitle {
  font-size: 13px;
}

img {
  margin-top: 10px;
}

@media (min-width: 992px) {
  .card {
    margin: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Notices/Content.vue